import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import thunk from "redux-thunk";

import authReducer from "./Slices/AuthSlice";
import mapReducer from "./Slices/MapSlice";
import listReducer from "./Slices/ListingSlice";
import allListingReducer from "./Slices/AllListing";
import allRequestReducer from "./Slices/AllRequest";
import selectedCategoryReducer from "./Slices/DynamicCategories";
import menuReducer from "./Slices/MenuSlice";
import pickUpReducer from "./Slices/PickUpDetails";
import poolingMapReducer from "./Slices/PoolingMapSlice";

const reducers = combineReducers({
  auth: authReducer,
  map: mapReducer,
  list: listReducer,
  allListing: allListingReducer,
  allRequest: allRequestReducer,
  selectedCategory: selectedCategoryReducer,
  allMenus: menuReducer,
  bookingAddress: pickUpReducer,
  pooling: poolingMapReducer,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: true,
  middleware: [thunk],
});

export const persistor = persistStore(store);
